import { render } from "./ThermsView.vue?vue&type=template&id=2021ae1c&scoped=true"
import script from "./ThermsView.vue?vue&type=script&lang=js"
export * from "./ThermsView.vue?vue&type=script&lang=js"

import "./ThermsView.vue?vue&type=style&index=0&id=2021ae1c&scoped=true&lang=css"

import exportComponent from "/builds/pazzei/pazzei-landing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2021ae1c"]])

export default __exports__